<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2 mat-dialog-title class="!pl-0 dialog-heading">
      Enter Your Drop Off Location
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    (click)="this._matDialogRef.close()"
  >
    <mat-icon class="text-orange-color text-xl">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div class="w-full">
    <form [formGroup]="this.form">
      <div class="row">
        <mat-form-field class="flex-1 form-field" appearance="fill">
          <!-- <label class="labelleading-4">Dropoff Address</label> -->
          <input
            (paste)="locationChange()"
            formControlName="pickupAddress"
            type="text"
            matInput
            class="form-control"
            (keydown.enter)="$event.preventDefault()"
            placeholder="Enter Exact Dropoff Location"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            #search
          />
          <mat-error>Location is required</mat-error>
        </mat-form-field>
      </div>
      <div class="row mb-8">
        <!-- <agm-map [restriction]="countryRestriction" class="h-72" [latitude]="latitude" [longitude]="longitude"
                        [zoom]="zoom">
                        <agm-marker [latitude]="latitude" [longitude]="longitude"
                            [markerDraggable]="form.status=='DISABLED'?false:true" (dragEnd)="markerDragEnd($event)">
                        </agm-marker>
                    </agm-map> -->

        <google-map
          height="200px"
          width="100%"
          [center]="{ lat: latitude, lng: longitude }"
          [zoom]="zoom"
          [options]="mapOptions"
        >
          <map-marker
            [position]="{ lat: latitude, lng: longitude }"
            [options]="markerOptions"
            (mapDragend)="markerDragEnd($event)"
            (mapDragend)="markerDragEnd($event)"
          >
          </map-marker>
        </google-map>
      </div>
      <div class="row">
        <mat-form-field class="flex-1 form-field" appearance="fill">
          <input
            formControlName="landMark"
            matInput
            class="mt-0"
            placeholder="Landmark "
          />
        </mat-form-field>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="m-0 justify-center !pb-5 !px-5">
  <button
    color="primary"
    (click)="onSubmit()"
    class="!bg-blue-theme-color !px-6 !h-11 text-white-color mx-auto mr-0"
    mat-flat-button
    [disabled]="this.form.invalid"
  >
    Done
  </button>
</mat-dialog-actions>
